import { render, staticRenderFns } from "./ValidatedVCard.vue?vue&type=template&id=bdeb2788&"
import script from "./ValidatedVCard.vue?vue&type=script&lang=ts&"
export * from "./ValidatedVCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VMessages } from 'vuetify/lib/components/VMessages';
installComponents(component, {VCard,VMessages})
